import { atom } from "jotai";

export interface IStockType {
    id?: number;
    name: string;
    description?: string | null;
    created_at?: string;
    updated_at?: string;
}

export interface IStockTypeInput extends Omit<IStockType, 'id' | 'created_at' | 'updated_at'> {}

export const stockTypesAtom = atom<IStockType[]>([]);
export const stockTypesLoadingAtom = atom<boolean>(false);

